import { render, staticRenderFns } from "./StatusCursosTab.vue?vue&type=template&id=3d6e46d4&scoped=true"
import script from "./StatusCursosTab.vue?vue&type=script&lang=js"
export * from "./StatusCursosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e46d4",
  null
  
)

export default component.exports